import pako from "pako";
import { toRenderStructDTOFromArray } from "../../util";
export const calculationSave = (apiClient) => {
    return {
        async build(params) {
            const dto = toRenderStructDTOFromArray(params.data);
            const compressed = pako.gzip(JSON.stringify(dto));
            const form = new FormData();
            // Бинарные данные
            form.append('data', new Blob([compressed], { type: 'application/octet-stream' }), 'data.bin');
            // Метаданные — просто JSON строки, никакого base64
            if (params.params) {
                form.append('params', JSON.stringify(params.params));
            }
            if (params.spec) {
                form.append('spec', JSON.stringify(params.spec));
            }
            if (params.leads) {
                form.append('leads', JSON.stringify(params.leads));
            }
            return apiClient.request(`/calculation/save?visibility=${params.visibility}`, form, 
            // Content-Type НЕ указываем — браузер сам выставит multipart/form-data с boundary
            {});
        },
    };
};
